import React, { useEffect } from 'react';
import makeStyles from '@mui/styles/makeStyles';
import IComponent from '../../../../services/forms.interface';
import TextField from "@mui/material/TextField";
import myxss from './myxss';
import styled from '@emotion/styled';
import Autocomplete from '@mui/material/Autocomplete';


interface ICustomProps {
    name: string;
    type: string;
    value: string;
    defaultValue: string;
    disabled: boolean;
    read_only: string;
    required: boolean;
    maskKey: string;
    error: any;
    onChange: any;
    onBlur: any;
    label: string;
    autoComplete: string;
}

const useStyles = makeStyles((theme) => ({
    formControl: {
        width: '100%'
    },
    textField: {
        width: '100%',
        
    },
    autoTextField: {
        width: '100%',
        padding: '2px 0px 2px 10px',
        color: '#606060'
    },
}));

const StyledTextField = styled(TextField)({
    '& .MuiOutlinedInput-root': {
        backgroundColor: '#F9F9F9',
        
    },
});

interface OptionType {
    key: string;
    label: string;
    value: string;
}

const AutoCompleteInput: React.FC<IComponent> = props => {
    const classes = useStyles();

    const [options, setOptions] = React.useState<OptionType[]>([]);
    const [value, setValue] = React.useState<OptionType>(null);

    // handles typing in the input field
    const handleChange = (event) => {

        const value = event.target.value;

        if (!value || value === '') 
            return;

        // check if the value is in the options array
        const foundOptions = options.filter((option) => {
            if (option.label.toLowerCase() === value.toLowerCase()) {
                return option;
            }
        });

        // check if the foundOptions array is empty
        if (foundOptions.length === 0) {
            props.handleChange(event, props.id, value);
        } else {
            // set the value to the first element of the foundOptions array
            setValue(foundOptions[0]);
            props.handleChange(event, props.id, foundOptions[0].value);
        }
    };

    // handles selecting an option from the dropdown
    const handleSelection = (event, option) => {
        if (!option) 
            return;

        props.handleChange(event, props.id, option.value);
    };

    const isRequired = (props.hasOwnProperty('required') && props.required === true && !props.read_only);
    const labelText = myxss.process(props.label);
    const localProps: ICustomProps = {} as ICustomProps;

    localProps.type = 'text';
    localProps.name = props.name;
    localProps.onChange = handleChange;
    localProps.required = isRequired;
    localProps.value = props.value ? props.value : '';
    localProps.label = labelText;
    localProps.disabled = props.disabled;
    localProps.autoComplete = props.autocomplete;
    localProps.onChange = handleChange;

    if (props.error) { localProps.error = true; }

    if (props.disabled)
        localProps.disabled = true;

    let baseClasses = 'item SortableItem rfb-item';
    if (props.editMode) { baseClasses += ' is-editing'; }
    if (!props.editMode) { baseClasses += ' not-is-editing'; }
    if (props.selected) { baseClasses += ' selected'; }


    useEffect(() => {

        if (!props.options || props.options.length === 0)
            return; 

        // remove duplicates from the options array
        const deduppedOptions = props.options?.filter((option, index, self) =>
            index === self.findIndex((o) => o.text === option.text)
        );

        // convert to OptionType
        const newOptions = deduppedOptions?.map((option) => {
            return {
                key: option.key,
                value: option.value,
                label: option.text
            } as OptionType;
        });

        setOptions(newOptions);

    }, [props.options]);


    useEffect(() => {

        if (!options || options.length === 0)
            return; 

        const foundOptions = options.filter((option) => {
            if (option.label.toLowerCase() === props.value.toLowerCase() || option.value.toLowerCase() === props.value.toLowerCase()) {
                return option;
            }
        });

        if (foundOptions.length > 0) {
            setValue(foundOptions[0]);
        } else {

            const newOptions = [...options];

            if (props.value && props.value !== '') {
                newOptions.unshift({
                    key: props.value,
                    value: props.value,
                    label: props.value
                });  
            } else {
                newOptions.unshift({
                    key: '',
                    value: '',
                    label: 'Select Provider'
                });
            }
            setOptions(newOptions);
            setValue(newOptions[0]);
        }

    }, [props.value, options]);

    if (!options)
        return <></>;


    return (
        <div className={baseClasses}>

            {props.options.length > 0 &&
            <Autocomplete
                value={value}
                onChange={(event, newValue) => {
                    handleSelection(event, newValue);
                }}
                options={options}

                    fullWidth
                autoHighlight
                freeSolo 
                    renderInput={(params) => <StyledTextField variant="outlined" {...params} {...localProps} fullWidth inputProps={{ ...params.inputProps, autoComplete: 'new-password', className: classes.autoTextField }} margin="none" size="small" />}
            />
            }
            {props.options.length === 0 &&
                <StyledTextField variant="outlined" {...localProps} fullWidth InputProps={{ className: classes.textField }} margin="none" size="small" />
            }
        </div>
    );
}

export default AutoCompleteInput;

